/**
 * @desc 可拆包裹列表
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageItemFacadeImpl.getDetachableList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/systemOrderPackage/getDetachableList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
